import styles from './Menu.module.css';

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

import { setPageTitle } from 'store/ducks/main.js';

import {
  DesktopOutlined,
  TeamOutlined,
  FolderOutlined,
  FieldTimeOutlined,
  ProfileOutlined,
  CloudServerOutlined,
  LineChartOutlined,
  WarningOutlined,
  PullRequestOutlined,
  Html5Filled,
  AuditOutlined,
  DollarOutlined
} from '@ant-design/icons';

import { ReactComponent as Logo } from 'assets/images/logo.svg';

import { Layout, Menu } from 'antd';
const { Sider } = Layout;

const UiMenu = ({ match }) => {
  const dispatch = useDispatch();

  const setTitle = (value) => dispatch(setPageTitle(value));

  return (
    <Sider>
      <div className={styles.logo}>
        <Logo />
      </div>
      <Menu theme="dark" defaultSelectedKeys={[match.params.page || 'dashboard']} mode="inline">
        <Menu.Item key="dashboard" className={styles.menuItem}>
          <Link to="/" onClick={() => setTitle('Dashboard')}>
            <DesktopOutlined />
            <span>Dashboard</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="trials" className={styles.menuItem}>
          <Link to="/trials" onClick={() => setTitle('Trials')}>
            <DollarOutlined />
            <span>Trials</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="statistics" className={styles.menuItem}>
          <Link to="/statistics" onClick={() => setTitle('Statistics')}>
            <LineChartOutlined />
            <span>Statistics</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="users" className={styles.menuItem}>
          <Link to="/users" onClick={() => setTitle('Users')}>
            <TeamOutlined />
            <span>Users</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="forms" className={styles.menuItem}>
          <Link to="/forms" onClick={() => setTitle('Forms')}>
            <FolderOutlined />
            <span>Forms</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="templates" className={styles.menuItem}>
          <Link to="/templates" onClick={() => setTitle('Templates')}>
            <ProfileOutlined />
            <span>Templates</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="logs" className={styles.menuItem}>
          <Link to="/logs" onClick={() => setTitle('Logs')}>
            <FieldTimeOutlined />
            <span>Logs</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="servers" className={styles.menuItem}>
          <Link to="/servers" onClick={() => setTitle('Servers')}>
            <CloudServerOutlined />
            <span>Servers</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="scamdetection" className={styles.menuItem}>
          <Link to="/scam" onClick={() => setTitle('Servers')}>
            <WarningOutlined />
            <span>Scam Detection</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="customCode" className={styles.menuItem}>
          <Link to="/customCode" onClick={() => setTitle('Custom Head Code Forms')}>
            <Html5Filled />
            <span>Custom Code</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="changelog" className={styles.menuItem}>
          <Link to="/changelog" onClick={() => setTitle('Changelog')}>
            <PullRequestOutlined />
            <span>Changelog</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="invoices" className={styles.menuItem}>
          <Link to="/invoices" onClick={() => setTitle('Invoices')}>
            <AuditOutlined />
            <span>Invoices</span>
          </Link>
        </Menu.Item>
      </Menu>
    </Sider>
  );
};

export default withRouter(UiMenu);
